/* Testimonials Section – Sacred Modern Design
 * Dark section with testimonial cards
 * Horizontal scrolling marquee effect
 */
import { TESTIMONIALS } from "@/lib/constants";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Star } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";

export default function TestimonialsSection() {
  const { t } = useI18n();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="section-dark py-24 lg:py-32 relative overflow-hidden" ref={ref}>
      <div className="absolute inset-0 mandala-overlay pointer-events-none" />

      <div className="container relative z-10">
        <div
          className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-sm font-semibold tracking-[0.2em] uppercase text-[oklch(0.52_0.09_128)]" style={{ fontFamily: "var(--font-body)" }}>
            {t("landing.testimonials.badge")}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[oklch(0.93_0.015_80)] mt-4 mb-6">
            {t("landing.testimonials.heading")}
          </h2>
        </div>

        {/* Testimonial Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((testimonial, i) => (
            <div
              key={i}
              className={`bg-[oklch(0.22_0.02_280)] rounded-2xl p-6 border border-[oklch(0.3_0.02_280)] hover:border-[oklch(0.52_0.09_128/0.3)] transition-all duration-500 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 100 + 200}ms` }}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className="text-[oklch(0.52_0.09_128)]" size={14} fill="oklch(0.78 0.11 85)" />
                ))}
              </div>

              <p className="text-[oklch(0.8_0.01_80)] leading-relaxed mb-4 italic" style={{ fontFamily: "var(--font-body)" }}>
                „{t(testimonial.textKey as any)}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-[oklch(0.3_0.02_280)]">
                <div className="w-8 h-8 rounded-full bg-[oklch(0.78_0.11_85/0.15)] flex items-center justify-center">
                  <span className="text-xs font-bold text-[oklch(0.52_0.09_128)]">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <span className="text-sm font-medium text-[oklch(0.7_0.02_80)]">
                  {testimonial.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
